import Vue from 'vue';
import VueRouter from 'vue-router';

import VueMeta from 'vue-meta';

import routes from './routes';
import permissionHelper from '@/helpers/permissionHelper';

import { auth } from '@/services/index';

Vue.use(VueRouter);
Vue.use(VueMeta, {
	// The component option name that vue-meta looks for meta info on.
	keyName: 'page',
})

const router = new VueRouter({
	routes,
	mode: 'history',
})

/**
 * Route Guard
 */
router.beforeEach(async (to, from, next) => {
	await resetCurrentPermission()
	const authToken = localStorage.getItem('auth_token');
	// If error page
	if (to.meta.error) {
		authToken || to.meta.public ? next() : next('/account/login');
	}
	// If page requires authentication
	else if (!to.meta.public) {
		// If user has page access
		if (authToken)
			isUserRoleAllowed(to) ? next() : next('/401');
		// If user is not allowed
		else 
			next('/account/login');
	}
	// If page is publicly accessible
	else {
		authToken ? next('/') : next();
	}
});

export default router;

const isUserRoleAllowed = (routeObject) => {
	if (!routeObject.meta.accessKey) {
		console.error('RouteError: This route has no access key attached.');
		return;
	}

	if (routeObject.name === 'View All Notifications') return true
	return permissionHelper.checkAccess(routeObject.meta?.accessKey, routeObject.meta?.accessType || 'check all');
}

const resetCurrentPermission = async () => {
	const STORAGE_USER = 'user';
	const STORAGE_TOKEN = 'auth_token';
	const appUser = localStorage.getItem(STORAGE_USER)
	const appToken = localStorage.getItem(STORAGE_TOKEN);
	if (!appUser || !appToken) return
	
	const user = JSON.parse(appUser)
	const response = await auth.getCurrentPermissions()
	user.role.accesses = response.data.accesses
	localStorage.setItem(STORAGE_USER, JSON.stringify(user));
};